import { CustomElement } from "../../core/CustomElement";

import ko from "knockout";
import CCCDialog from "../dialog/dialog";

export default class JiraDialogVM {
  $customElement: CustomElement;
  // Observables.
  uiUrl: KnockoutObservable<string>;

  constructor($customElement: CustomElement) {
    this.$customElement = $customElement;
    this.uiUrl = ko.observable();
  }

  closeDialog: () => void = () => {
    (
      this.$customElement.shadowDom.querySelector(
        ".ccc-jira-dialog"
      ) as CCCDialog
    ).close();
  };
}
